export const Routes = {
  Main: '/',
  Auctions: '/auctions',
  Auction: '/auction-[id]',
  Artworks: '/artworks/[[page]]',
  Artwork: '/artwork-[id]-[slug]/[[param1]]',
  Classification: '/artworks/classification-[classificationCategory]-[nameOfClassification]/[[page]]',
  Artists: '/artists',
  Artist: '/artist-[id]-[slug]/[[page=page]]',
  FAQ: '/faq',
  AboutUs: '/about-us',
  ContactUs: '/contact-us',
};
